import { formatBelegdatum } from "@/lib/dokumente";

/** Entspricht api/gd_leistungsdatum.EQUALS_INVOICE_NOTE. */
export const EQUALS_INVOICE_NOTE = "Leistungsdatum entspricht Rechnungsdatum";

function isoDay(value?: string | null): string {
  return (value || "").slice(0, 10);
}

type SupplyDoc = {
  dokument_typ?: string | null;
  belegdatum?: string | null;
  leistungsdatum?: string | null;
  lieferdatum?: string | null;
  leistungszeitraum_von?: string | null;
  leistungszeitraum_bis?: string | null;
};

/**
 * Anzeige wie im Rechnungs-Infoblock (Standardmodus):
 * Zeitraum, sonst abweichendes Liefer-/Leistungsdatum, sonst der Kurzvermerk.
 */
export function supplyDateSummary(doc: SupplyDoc, belegdatum?: string | null): string | null {
  const von = isoDay(doc.leistungszeitraum_von);
  const bis = isoDay(doc.leistungszeitraum_bis);
  const leistung = isoDay(doc.leistungsdatum);
  const liefer = isoDay(doc.lieferdatum);
  const beleg = isoDay(belegdatum ?? doc.belegdatum);
  const start = von || bis || leistung || liefer;
  const end = bis || von || leistung || liefer;
  if (start && end && start !== end) {
    return `Leistungszeitraum: ${formatBelegdatum(start)} – ${formatBelegdatum(end)}`;
  }
  const single = leistung || liefer || (start && start === end ? start : "");
  if (single && single !== beleg) {
    const goods = Boolean(liefer) && (!leistung || leistung === liefer);
    const label = goods ? "Lieferdatum" : "Leistungsdatum";
    return `${label}: ${formatBelegdatum(single)}`;
  }
  if (doc.dokument_typ === "rechnung" && beleg) return EQUALS_INVOICE_NOTE;
  if (single) return `Leistungsdatum: ${formatBelegdatum(single)}`;
  return null;
}
